function Loading() {
  return (
    <div className=" fixed w-full h-full bg-white/70 flex justify-center items-center left-0 top-0 z-50">
      <img alt="loader" src="../../images/loading.gif" className=" w-[200px]" />
    </div>
  );
}
export default Loading;
